import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ReachTemplateContentChannel, ReachTemplateRenderResponse} from "./types";

export type RenderTemplateInlineVariables = {
  account_id: number;
  template_key: string;
  content_channel: ReachTemplateContentChannel;
  body: string;
  subject: string | null;
  pre_header: string | null;
  landing_page_body: string | null;
  channel_message_code: string | null;
};

const renderTemplateInline = async (
  variables: RenderTemplateInlineVariables
): Promise<ReachTemplateRenderResponse> => {
  const response = await axiosReachInstance.post<
    ReachTemplateRenderResponse,
    AxiosResponse<ReachTemplateRenderResponse>,
    RenderTemplateInlineVariables
  >("/templates/render-inline", variables);
  return response.data;
};

export const useRenderTemplateInline = (
  options?: BaseMutationOptions<ReachTemplateRenderResponse, RenderTemplateInlineVariables>
): BaseUseMutationResult<ReachTemplateRenderResponse, RenderTemplateInlineVariables> =>
  useBaseMutation<ReachTemplateRenderResponse, RenderTemplateInlineVariables>(
    renderTemplateInline,
    options
  );
